import pictoHome from '/images/home-marker.svg';

/**
 * Function utilisée par le flexible Content  "Carte Nounou"
 * 
 *  
 *  Idée de l'aglorithme
 *   N°1 - au chargement de la carte, on effectue une requete correspondant à la surface de la carte + 20%.
 *         tant que la carte reste à l'intérieur de ce rectangle augmenté, il n'y a pas besoin de refaire une requete lors d'un drag sur la carte
 *   N°2 - On mémorise tous les rectangles de recherche . si la carte reste à l'intérieur d'un des rectangles de recherche précédent, pas besoin de refaire une requète ajax
 *   N°3 - au changement du niveau de zoom, on réinitialise tout
 *   N°4 - Si une requete me donne moins de picto que le nombre demandé, alors tout zoom suplémentaire ne necessite pas de requete car ce sera un sous ensemble de la requete précédente
 *   N°5   -Afin de répartir géographiquement les pictos : pour afficher 50 pictos, on en demande 150 au serveur. 
 *          Le rectangle constituant la carte est divisé en 4 parties égales. on distribue au hazard un picto dans chacune des 4 cases.
 *          au tour suivant, on redivise chaque case en 4 parties et on distribue les pictos restants dans chaque case vide.
 *          on s'arrete quand on a distribué nos 50 pictos
 *
 * 
 *   Optimisation possible :  
 *   TODO Performance - au delà d'un certain nombre de markers en mémoire (ex > 300), on supprime les markeurs les plus loins du centre ou hors carte 
 */

(function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { CarteNounou : { map : null}});
     
    /**
    * Charge la carte
    * @zoom niveau de zoom de la carte
    * @latitude latitude du centre de la carte
    * @longitude longitude du centre de la carte
    * @densite densitée de picto à affiché en Picto/pixel²
    */
    w.Kinougarde.CarteNounou.ChargerCarte = function(zoom,latitude,longitude,densite) {

        var self = this;
        self.densite = parseInt(densite);
        self.Latitude = parseFloat(latitude);
        self.Longitude = parseFloat(longitude);
        self.markers = [];
        self.niveauZoomMaxPourVoirTousLespictos = null;
        self.lastAjaxRecherche = [];
        googleMapsLoadedPromise.then(function() {
            // Exécuté quand l'API google est chargée            
            console.debug("chargement API OK");
            
            self.icon = {path: "m 29.7 90 c 1.35 0 2.61 -0.6 3.51 -1.6 c 0.27 -0.3 6.57 -7.5 12.87 -17.6 c 8.82 -14.1 13.32 -26.5 13.32 -37 c 0 -18.7 -13.32 -33.8 -29.7 -33.8 s -29.7 15.1 -29.7 33.8 c 0 10.5 4.5 23 13.32 37 c 6.39 10.1 12.6 17.3 12.87 17.6 c 0.9 1 2.16 1.6 3.51 1.6 z m -12.69 -59.5 c 0 -8 5.67 -14.5 12.69 -14.5 s 12.69 6.5 12.69 14.5 s -5.67 14.5 -12.69 14.5 s -12.69 -6.5 -12.69 -14.5 z",
                fillColor     : '#D1007F',
                fillOpacity   : 1,
                strokeWeight  : 0,
                strokeOpacity : 1,
                scale         : 0.35,            
                anchor        : new google.maps.Point(0,0)};                                    
            self.iconHome = {
                url: pictoHome,  
                fillColor     : '#0000',
                fillOpacity   : 1,
                strokeWeight  : 0,
                strokeOpacity : 1,
                scaledSize    :  new google.maps.Size(30,40),            
                anchor        : new google.maps.Point(0,0)};                                    
    
            self.iconInactif = {path: "m 29.7 90 c 1.35 0 2.61 -0.6 3.51 -1.6 c 0.27 -0.3 6.57 -7.5 12.87 -17.6 c 8.82 -14.1 13.32 -26.5 13.32 -37 c 0 -18.7 -13.32 -33.8 -29.7 -33.8 s -29.7 15.1 -29.7 33.8 c 0 10.5 4.5 23 13.32 37 c 6.39 10.1 12.6 17.3 12.87 17.6 c 0.9 1 2.16 1.6 3.51 1.6 z m -12.69 -59.5 c 0 -8 5.67 -14.5 12.69 -14.5 s 12.69 6.5 12.69 14.5 s -5.67 14.5 -12.69 14.5 s -12.69 -6.5 -12.69 -14.5 z",
                fillColor     : '#D3AFBE',
                fillOpacity   : 1,
                strokeWeight  : 0,
                strokeOpacity : 1,
                scale         : 0.30,            
                anchor        : new google.maps.Point(0,0)}; 
            // Création de la carte
            const kinougardeMapStyle =
            [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.highway", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "transit", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit.station", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "stylers": [ { "color": "#aad2e3" }, { "visibility": "on" } ] } ];                        

            self.map = new google.maps.Map(document.getElementById("map"), {
                center: { lat: self.Latitude, lng: self.Longitude },
                zoom: parseInt(zoom),
                styles : kinougardeMapStyle,  
                streetViewControl : false,              

            });            
            
            google.maps.event.addListenerOnce( self.map,'bounds_changed', function() {
                // 1er chargement de la carte
                console.debug("bounds_changed");                
                Kinougarde.CarteNounou.RefreshCarte(false);                
            });
            google.maps.event.addListener(self.map,'zoom_changed', function() {
                console.debug("zoom_changed");
                Kinougarde.CarteNounou.RefreshCarte(true);
            });
            google.maps.event.addListener(self.map,'dragend', function() {
                console.debug("dragend");
                Kinougarde.CarteNounou.RefreshCarte(false);
            });
            
        });  
            
        
    };

    /**
     * Mettre à jour la carte
     */
    w.Kinougarde.CarteNounou.RefreshCarte = function(clearMarkers) {
        var self = this;
               
        var limiteCarte = this.map.getBounds();
        var limiteRecherche =  new google.maps.LatLngBounds(this.getSouthWestRecherche(),this.getNorthEastRecherche());
        
        console.debug("Limite carte " +  limiteCarte);
               
        // Si la carte reste dans un rectangle de recherche précédent, et que clearMarkers==false
        // pas besoin de refaire une requete
        if (!clearMarkers && self.lastAjaxRecherche.length>0) {
            var carteDansUnrectangleConnu = false;
            self.lastAjaxRecherche.forEach(rectangleConnu => {
                if (rectangleConnu.contains(limiteCarte.getNorthEast()) &&
                    rectangleConnu.contains(limiteCarte.getSouthWest()) ) {
                        console.debug("OPTIMISATION - Carte contenue dans " +  rectangleConnu);                   
                    carteDansUnrectangleConnu = true;
                } 
            });     
            // Pas de requête Ajax si la carte est contenue dans un rectangle connu
            if (carteDansUnrectangleConnu) return;
        }
        // Optimisation 4
        if (clearMarkers && this.niveauZoomMaxPourVoirTousLespictos!==null && this.niveauZoomMaxPourVoirTousLespictos<=this.map.getZoom()) {
            // Le resultat de la requete sera un sous ensemble de la précédente.
            // Pas besoin de faire un appel au serveur
            return;
        } else {
            this.niveauZoomMaxPourVoirTousLespictos = null;
        }
                
        var data = { action : "ajax_carte_nounou",
                     Latitude : this.Latitude,
                     Longitude: this.Longitude, 
                     LatitudeNE :  limiteRecherche.getNorthEast().lat(),
                     LongitudeNE :  limiteRecherche.getNorthEast().lng(),
                     LatitudeSO :  limiteRecherche.getSouthWest().lat(),
                     LongitudeSO :  limiteRecherche.getSouthWest().lng(),
                     NombrePicto : this.GetNbPictoAAfficher(this.densite)
        };
        //Si une requete est déjà en cours, on l'annule pour
        // en faire une nouvelle avec le dernier positionnement de la carte
        if(typeof(this.ajaxEnCours)!=='undefined' && this.ajaxEnCours!==null) {
            this.ajaxEnCours.abort();  
            this.ShowLoaderMap(false,this.map);          
        }

        if (data.LatitudeNE==90 || data.LatitudeSO==-90) {
            // Limite de la terre, on ne fait pas de requete
            return;
        }

        console.debug("Recherche sur " + limiteRecherche);
        this.ShowLoaderMap(true,this.map);
       
        //$("#map-ajax-loader").removeClass("hidden");
        $("#infobox-nounou").addClass("hidden");
        this.SelectMarker(null);
        // Appel Ajax pour trouver les pictos de la zone
        this.ajaxEnCours =  $.ajax({
            type     : 'POST',
            dataType : 'json',
            url      : ajax_kinougarde_object.ajaxurl,
            data     : data,
            success  : function (reponse) {
                //$("#map-ajax-loader").remove();                
                self.ShowLoaderMap(false,self.map);
                
                // Optimisation 4 
                if (reponse.data.Intervenants.length <  data.NombrePicto) {
                    self.niveauZoomMaxPourVoirTousLespictos = self.map.getZoom();
                } else {
                    self.niveauZoomMaxPourVoirTousLespictos = null;
                }
                
                // Suppression des markers si on zoom
                if (clearMarkers) {
                    self.ClearMarkers();
                    self.lastAjaxRecherche = [];
                }
                // Ajout cette recherche dans la iste des recherches
                self.lastAjaxRecherche.push(limiteRecherche);
                self.ajaxEnCours = null;
                var nouveauPicto = reponse.data.Intervenants.filter((intervenant) => {
                    return !self.markers.some((el)=> {return el.IdKinougarde == intervenant.Id;});
                });

                if (self.markers.length===0) {
                    //On ajout le marker Home lors de la première recherche uniquement
                    self.markers = self.markers.concat(new google.maps.Marker({ map : self.map,
                            position : { lat: self.Latitude, lng : self.Longitude},
                            IdKinougarde : 0,
                            intervenant : null,
                            icon: self.iconHome                         
                        }));                    
                }

                
                // Affiche les markers sur la carte
                self.markers = self.markers.concat(nouveauPicto.map((intervenant,i) => {                                        
                    var marker = new google.maps.Marker({ map : self.map,
                        position : { lat: intervenant.Latitude, lng : intervenant.Longitude},
                        IdKinougarde : intervenant.Id,
                        intervenant : intervenant,
                        icon: self.icon                         
                    });  
                    marker.addListener("click", (m)=> {    
                        self.SelectMarker(marker);
                    });
                    
                    return marker;           
                }));
                console.debug(nouveauPicto.length + " nouveaux marker , Total : " + self.markers.length);
                
            },                    
            error: function (reponse) {
                self.ShowLoaderMap(false,self.map);
                self.ajaxEnCours =null;
            }
        });             
        
    }


    /**
     * Divise la carte en 4 , 16, 64 ou 256 zones
     * selon le niveau demandé
     * -----------------
     * |   1   |   2   |
     * |---------------|
     * |   3   |   4   |
     * |---------------|
     */
    // w.Kinougarde.CarteNounou.DiviseCarte = function(limiteRecherche,niveau) {

    //     var deltaLatitude = (limiteRecherche.getNorthEast().lat()-limiteRecherche.getSouthWest().lat())/Math.pow(2,niveau);
    //     var deltaLongitude = (limiteRecherche.getNorthEast().lng()-limiteRecherche.getSouthWest().lng())/Math.pow(2,niveau);
    //     var zones = new Array(Math.pow(4,niveau));
    //     for (let i = 0; i < Math.pow(2,niveau); i++) {
    //         for (let j = 0; j < Math.pow(2,niveau); j++) {
    //         }            
    //     }
    // }


    /**
     * Retourne le premier intervenant de la liste contenu dans la zone.
     * Retourne undefined si aucun intervenant n'appartient à la zone géographique
     */
    // w.Kinougarde.CarteNounou.TrouveIntervenantDansZone = function(listeIntervenants,zone) {
    //     return listeIntervenants.find(function(intervenant,index) { 
    //         var positionIntervenant = new google.maps.LatLngBounds(intervenant.Latitude,intervenant.Longitude);
    //         return zone.contains(positionIntervenant);
    //     }); 
    // }


    /**
     * Retourne la liste des intervenant à positionner sur la carte
     * @param {zone géographique traitée} zoneGeographique 
     * @param {Liste de tous les intervenants restants} listeIntervenants      
     * @param {Liste des intervenants selectionné pour être affiche sur la carte} listeIntervenantsDansCarte
     * @param {niveau de profondeur de l'aglorithme} niveau
     */
    // w.Kinougarde.CarteNounou.RepartitionGeographiqueDesPictos = function(zoneGeographique, listeIntervenants) {                       

    //     var intervenantsDansCarte = [];
    //     var niveau = 1;

    //     while(intervenantsDansCarte.length<NombreDemande) {

    //     //Divise la carte en 4 au niveau 1, en 16 au niveau 2, en 64 au niveau 3, en 256 au niveau 4 , etc ..
    //     var listeZone = this.DiviseCarte(zoneGeographique,niveau);

    //     listeZone.forEach(zone => {
    //         var intervenantTrouve = this.TrouveIntervenantDansZone(listeIntervenants,zone);
    //         var intervenantDejaDansCetteZone = this.TrouveIntervenantDansZone(intervenantsDansCarte,zone);
    //         if (typeof(intervenantTrouve)!=='undefined' && typeof(intervenantDejaDansCetteZone)==='undefined') {
    //             // On ajoute l'intervenant si il n'y a aucun intervenant dans cette zone
    //             intervenantsDansCarte.push(intervenantTrouve);
    //             listeIntervenants.splice(listeIntervenants.indexOf(intervenantTrouve),1);
    //         }
    //     });

    //     niveau++;       

    //     }
              
    //     return intervenantsDansCarte;

    // }

    /**
     * Selection d'un marker sur la carte
     * @param {Selectionne } marker 
     */
    w.Kinougarde.CarteNounou.SelectMarker = function(marker) {
        var self =this;
        if (marker!==null) {
            // Affiche l'info box                    
            $("#infobox-nounou").html(this.GetHtmlInfoBox(marker.intervenant)); 
            $("#infobox-nounou").removeClass("hidden");
            // Fermeture de l'infobox
            $("#infobox-nounou button.close").on('click', function() {
                $("#infobox-nounou").addClass("hidden");
                self.markers.forEach(m => {
                    if (m.IdKinougarde!==0) {
                        m.setIcon(self.icon);
                    }
                });
            });  
            //change l'icone à inactif pour tout les autres picto
            this.markers.forEach(m => {
                if (m.IdKinougarde!==0) {
                    m.setIcon(this.iconInactif);
                }
            });
            marker.setIcon(this.icon);
        } else {
            // pas de marker on réactive tous les icons            
            this.markers.forEach(m => {
                if (m.IdKinougarde!==0) {
                    m.setIcon(this.icon);
                }
            });
        }
    }

    /**
     * Retourne le HTML de l'infobox
     * @param {string} marker 
     */
    w.Kinougarde.CarteNounou.GetHtmlInfoBox = function(intervenant) {
       
        var html ="";        
        html += "<p class=\"distance\">A <span class=\"value\">"+ intervenant.Distance+"</span> km</p><button type=\"button\" class=\"close\">&nbsp;</button>";
        if (intervenant.CodeSexe===2) {
            html += "<div class=\"userwoman\">";
        } else {
            html += "<div class=\"user\">";
        }
        html += "<strong>"+ intervenant.Prenom+ "</strong>";
        html += "<span class=\"age\">"+intervenant.Age+" ans</span>";
        html += "</div>";
        if(intervenant.Moins1An===true) {
            html += "<p class=\"garde_enfants\">Garde d'enfants 0 - 11 ans</p>";
        } else if (intervenant.Moins3Ans===true) {
            html += "<p class=\"garde_enfants\">Garde d'enfants 1 - 11 ans</p>";
        } else  {
            html += "<p class=\"garde_enfants\">Garde d'enfants 3 - 11 ans</p>";
        }
        html += "<p class=\"recrutement\">Recruté(e) le "+ new Date(intervenant.DateRecrutement).toLocaleDateString('fr')+"</p>";
        if (intervenant.Vehicule===true) {
            html += "<div class=\"has-vehicle\">Véhiculé</div>";
        }
        if (intervenant.DevoirsNiveauCP===true || intervenant.DevoirsNiveauCM===true ) {
            html += "<div class=\"services\"><p>Service(s) complémentaire(s) : </p>";
            html += "<ul class=\"services-list\">";
            if (intervenant.DevoirsNiveauCP===true && intervenant.DevoirsNiveauCM===true) {
            html += "<li>Suivi des devoirs : CP-CE1-CE2-CM1-CM2 </li>";
            } else if (intervenant.DevoirsNiveauCP===true) {
                html += "<li>Suivi des devoirs : CP-CE1-CE2</li>";
            } else if (intervenant.DevoirsNiveauCM===true) {
                html += "<li>Suivi des devoirs :CM1-CM2</li>";                
            }           
            html += "</ul>";
            html += "</div>";        
        }
        
        return html;
    }

    /**
     * Supprime tous les markers de la carte
     * @param {markers} Liste des markers
     */
    w.Kinougarde.CarteNounou.ClearMarkers = function() {
        var markers = this.markers;        
        if (typeof(markers)!=='undefined' && markers!==null) {
            markers.forEach(m => {
                m.setMap(null);            
            });
        }
        this.markers= [];
    }


    /**
     * Ajoute 
     * @param {*} show 
     */
    w.Kinougarde.CarteNounou.ShowLoaderMap = function(show,map)  {
        if (show===true) {
            // Affiche le loader
            this.controlLoaderMap = document.createElement("div");               
            this.controlLoaderMap.id = "control-map-ajax-loader";
            this.controlLoaderMap.appendChild(jQuery("<div id=\"map-ajax-loader\">Chargement en cours ...</div>")[0]);
            map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.controlLoaderMap);                         
        } else {
            // Masque le loader
            map.controls[google.maps.ControlPosition.TOP_CENTER].forEach(function(element,index) {
                if (element.id == "control-map-ajax-loader") {                
                    map.controls[google.maps.ControlPosition.TOP_CENTER].removeAt(index);
                }
            });
        }
    }

    /**
     * Fonction qui retourne le point NordEst augmenté de x%
     * permet l'optimisation  N°1
     * 
     *    ------------------
     *    |   ----------   |              
     *    |   |        |   |
     *    |   |        |   |
     *    |   ----------   |
     * 0  ------------------ 
     *    0
     */
    w.Kinougarde.CarteNounou.getNorthEastRecherche = function() {
        var limiteCarte = this.map.getBounds();
        const facteur = 0.2; // augmentation de 30%
        var deltaLatitudeEtLongitude =  Math.min(Math.abs(limiteCarte.getNorthEast().lat()-limiteCarte.getSouthWest().lat()),
                                                  Math.abs(limiteCarte.getNorthEast().lng()-limiteCarte.getSouthWest().lng()))*facteur;
        return {lat : limiteCarte.getNorthEast().lat() + deltaLatitudeEtLongitude , lng : limiteCarte.getNorthEast().lng() +  deltaLatitudeEtLongitude};
    }

    /**
     * Fonction qui retourne le point NordEst augmenté de x%
     * permet l'optimisation  N°1
     */
     w.Kinougarde.CarteNounou.getSouthWestRecherche = function() {
        var limiteCarte = this.map.getBounds();
        const facteur = 0.2; // augmentation de 30%
        var deltaLatitudeEtLongitude =  Math.min(Math.abs(limiteCarte.getNorthEast().lat()-limiteCarte.getSouthWest().lat()),
                                                  Math.abs(limiteCarte.getNorthEast().lng()-limiteCarte.getSouthWest().lng()))*facteur;
        return {lat : limiteCarte.getSouthWest().lat() - deltaLatitudeEtLongitude , lng : limiteCarte.getSouthWest().lng() -  deltaLatitudeEtLongitude};
    }

    /**
     * Retourne le nombre de picto à afficher par Million de pixel²
     * Celui ci est function:
     * -  de la taille de la carte (donc de la taille de l'écran)
     * -  de la densité d'affichage demandée
     */
    w.Kinougarde.CarteNounou.GetNbPictoAAfficher = function(densite) {
        var map = document.getElementById("map");
        return  Math.ceil((map.clientHeight *  map.clientWidth * densite)/1000000);
    }


})(window);



